import { useEffect } from 'react'

export interface DocumentTitleProps {
  title: string
}

/**
 * Sets the document.title
 */
function DocumentTitle({ title }: DocumentTitleProps) {
  const prefixedTitle = `PaintScout | ${title}`
  useEffect(() => {
    document.title = prefixedTitle
  }, [prefixedTitle])

  return null
}

export default DocumentTitle
